import * as Styled from './Clickable.styled';
import type { ClickableProps } from './Clickable.types';
import React from 'react';

const Clickable = React.forwardRef<HTMLButtonElement, ClickableProps>(
  (props, ref) => {
    const { children, ...rest } = props;

    return (
      <Styled.Clickable {...rest} ref={ref}>
        {children}
      </Styled.Clickable>
    );
  },
);

Clickable.displayName = 'Clickable';

export { Clickable };
